import React, { useContext, useState } from 'react';
import classnames from 'classnames';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import isSSR from '../utils/isSSR';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useMessageListener } from '@wix/da-hooks/pkg/useMessageListener';
import s from './IframePopup.scss';

const POPUP_TITLE_HEIGHT = 68;

export interface Props {
  title?: string;
  src: string;
  initialWidth?: number;
  initialHeight?: number;
  className?: string;

  style?: React.CSSProperties;
  onMessage?: (message: MessageEvent) => void;
}

const IframePopup: React.FC<Props> = ({
  title,
  src,
  initialWidth = 400,
  initialHeight = 300,
  className,
  onMessage,
  style,
}) => {
  const isMobile = useContext(MobileContext);
  const [loaded, setLoaded] = useState(false);
  useMessageListener(onMessage);

  const isMobileClient = isMobile && !isSSR();
  const width = isMobileClient ? window.innerWidth : initialWidth;
  const height = isMobileClient ? window.innerHeight : initialHeight;

  return (
    <div className={s['root']} style={{ width, height, ...style }}>
      {title && <div className={s['title']}>{title}</div>}
      <iframe
        title={title}
        className={classnames(s['iframe'], className)}
        src={src}
        width={width}
        height={title ? height - POPUP_TITLE_HEIGHT : height}
        onLoad={() => setLoaded(true)}
        style={style}
      />
      {!loaded && <LoadingIndicator coverMode withOverlay view="daSymbol" />}
    </div>
  );
};
IframePopup.displayName = 'IframePopup';

export default IframePopup;
